import React, { FC } from "react";
import { FormControlLabel, Switch } from "@mui/material";
import { Control, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { CreateUpdateEntityFormValues } from "../../EntityEditor";

interface IsExternal {
  control: Control<CreateUpdateEntityFormValues>;
}

const IsExternal: FC<IsExternal> = ({ control }) => {
  const { t } = useTranslation();

  return (
    <Controller
      control={control}
      name="isExternal"
      render={({ field: { onChange, name, value } }): React.ReactElement => (
        <FormControlLabel
          name={name}
          onChange={onChange}
          control={<Switch checked={value ?? false} />}
          label={t("entitiesManagement.entityEditor.isExternal")}
        />
      )}
    />
  );
};

export default IsExternal;
